import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=cae92838&scoped=true&lang=pug&"
import script from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=cae92838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae92838",
  null
  
)

export default component.exports